import EndBt from './src/index.vue'

EndBt.install = function(Vue) {
  Vue.component(EndBt.name, EndBt)
}
export default EndBt
